import { render } from "./Start.vue?vue&type=template&id=2cef4b22&scoped=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import "./Start.vue?vue&type=style&index=0&id=2cef4b22&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2cef4b22"

export default script